<template>
    <div>
        <nav>
            <div class="div-tabs">
                <div class="nav nav-tabs" role="tablist">
                    <button @click="clickTab(Tab.id)" v-for="Tab in tabs" :key="Tab.id" class="nav-link"
                            :class="{ 'active actived': tabId === Tab.id }" data-bs-toggle="tab" type="button"
                            :aria-controls="Tab.target" :style="Tab.id !== 0 ? 'margin-right:2px' : ''">
                        <i :class="Tab.icon + ' text-tab'"></i>
                        <span class="text-tab-tittle">
                            {{ Tab.title }}
                        </span>
                    </button>
                </div>
            </div>
        </nav>
        <div class="tab-content border bordered">
            <component :ref="currentTabComponent" :is="currentTabComponent" v-bind="{ ...$attrs, ...contentProps }" />
        </div>
    </div>
</template>

<script>

    import Dados from '@/views/Modais/Ocorrencia/Tabs/Dados'
    import Tarefas_Executar from '@/views/Modais/Ocorrencia/Tabs/Tarefas_Executar'
    import Agendamento from '@/views/Modais/Ocorrencia/Tabs/Agendamento'
    import Anotacoes from '@/views/Modais/Ocorrencia/Tabs/Anotacoes'
    import Email from '@/views/Modais/Ocorrencia/Tabs/Email'
    import Usuarios from '@/views/Modais/Ocorrencia/Tabs/Usuarios'
    import Usabilidade from '@/views/Modais/Ocorrencia/Tabs/Usabilidade'
    import Contato from '@/views/Modais/Ocorrencia/Tabs/Contato'
    import Proposta from '@/views/Modais/Ocorrencia/Tabs/Proposta'
    import Processo from '@/views/Modais/Ocorrencia/Tabs/Processo'
    /*    import Whatsapp from '@/views/Tickets/Ticket_Crud/Tabs/Whatsapp'*/
    import Videochamada from '@/views/Modais/Ocorrencia/Tabs/Videochamada'
    import Cortesia from '@/views/Modais/Ocorrencia/Tabs/Cortesia'
    import Dados_Chamado from '@/views/Modais/Ocorrencia/Tabs/Dados_Chamado'
    import Mensagens_Chamado from '@/views/Modais/Ocorrencia/Tabs/Mensagens_Chamado'
    import Anexos_Chamado from '@/views/Modais/Ocorrencia/Tabs/Anexos_Chamado'
    import Status_Chamado from '@/views/Modais/Ocorrencia/Tabs/Status_Chamado'
    import SolicitacaoContato from '@/views/Modais/Ocorrencia/Tabs/SolicitacaoContato'
    import Inscricao from '@/views/Modais/Ocorrencia/Tabs/Inscricao'
    import PropostaEventos from '@/views/Modais/Ocorrencia/Tabs/PropostaEventos'


    export default {
        emits: ['tab-clicked'],
        props: {
            tabs: {
                type: Array,
                required: true,
            },
            defaultComponent: {
                type: String,
            },
            contentId: {
                require: true,
            },
            contentProps: {
                type: Object,
                require: true,
            },
            reloadContent: {
                type: Boolean,
                require: true
            },
            idOcorrencia: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
            ocorrenciaTabSelect: {
                type: Number,
                default: 0
            }

        },
        components: {
            Dados,
            Tarefas_Executar,
            Agendamento,
            Anotacoes,
            Email,
            Usuarios,
            Usabilidade,
            Contato,
            Proposta,
            PropostaEventos,
            Processo,
            /*Whatsapp,*/
            Videochamada,
            Cortesia,
            Dados_Chamado,
            Mensagens_Chamado,
            Anexos_Chamado,
            Status_Chamado,
            SolicitacaoContato,
            Inscricao
        },
        data() {
            return {
                tabId: 1,
                currentTabComponent: '',
            }
        },

        mounted() {
            this.setDefault();

        },
        methods: {
            setDefault() {
                if (this.ocorrenciaTabSelect > 0) {
                    const isIdOcorrenciaTab = this.tabs.find((tabId => tabId.cdOcorrenciaTab === this.ocorrenciaTabSelect))
                    this.currentTabComponent = isIdOcorrenciaTab.componentName
                    this.clickTab(isIdOcorrenciaTab.id);
                } else {
                    this.clickTab(this.tabs[0].id);
                }
            },
            clickTab(idTab) {
                this.tabId = idTab
                const tab = this.tabs.find((Tab) => Tab.id === idTab);
                if (tab) {
                    this.currentTabComponent = tab.componentName;
                }
                this.$emit('tab-clicked', this.tabId);
            },

        },
        watch: {
            contentId(n, o) {
                this.setDefault();
            },
            reloadContent() {
                this.setDefault();
            },
            idOcorrencia(n, o) {
                if (n != o) {
                    this.setDefault();
                } else {
                    this.setDefault();
                }
            },
            idModulo(n, o) {
                if (n != o) {
                    this.setDefault();
                } else {
                    this.setDefault();
                }
            },
        },

    }

</script>

<style scoped lang="scss">

    .div-tabs {
        overflow-x: auto;
        overflow-y: hidden;
    }

    .nav-tabs {
        border-bottom: var(--bs-nav-tabs-border-width) solid #9f3029;
        width: 1600px;


        .nav-link {
            border-top: var(--bs-nav-tabs-border-width) solid #a5a2a2;
            border-right: var(--bs-nav-tabs-border-width) solid #a5a2a2;
            border-left: var(--bs-nav-tabs-border-width) solid #a5a2a2;

            &.active {
                border-bottom: 1px solid #f9f9f9;
                background-color: #f9f9f9;
                border-top: var(--bs-nav-tabs-border-width) solid #9F3029;
                border-right: var(--bs-nav-tabs-border-width) solid #9F3029;
                border-left: var(--bs-nav-tabs-border-width) solid #9F3029;

                &:hover {
                    border-bottom: 1px solid #f9f9f9 !important;
                    border-top: var(--bs-nav-tabs-border-width) solid #9F3029;
                    border-right: var(--bs-nav-tabs-border-width) solid #9F3029;
                    border-left: var(--bs-nav-tabs-border-width) solid #9F3029;
                }
            }

            &:hover {
                border-bottom: var(--bs-nav-tabs-border-width) solid #9F3029;
                border-top: var(--bs-nav-tabs-border-width) solid #a5a2a2;
                border-right: var(--bs-nav-tabs-border-width) solid #a5a2a2;
                border-left: var(--bs-nav-tabs-border-width) solid #a5a2a2;
            }
        }
    }

    @media(min-width:1604px) {
        .nav-tabs {
            width: 100%;
        }
    }

    @media(min-width:1604px) {
        .div-tabs {
            overflow-x: hidden;
        }
    }

    .nav-link {
        padding: 4px 15px 4px 15px;
        font-weight: bold !important;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
        font-size: 14px !important;
        color: #BBBBBB !important;

        &.active {
            background: #f9f9f9;
        }

        &:hover {
            color: #9f3029 !important;
        }
    }

    .text-tab {
        font-weight: bold;
        font-size: 14px;

        &-tittle {
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            margin-left: 5px;
        }
    }

    .actived {
        color: #9f3029 !important;
    }

    .bordered {
        border-bottom: 1px solid #9f3029 !important;
        border-left: 1px solid #9f3029 !important;
        border-right: 1px solid #9f3029 !important;
    }

    .tab-content {
        padding: 10px;
        padding-bottom: 0;
        overflow-y: auto;
        overflow-x: hidden;
        max-height: calc(100vh - 11rem);
        height: calc(100vh - 11rem);
        border-top: transparent !important;
    }
</style>